if (!customElements.get('collection-seo-description')) {
  class CollectionSeoDescription extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-collection-seo-toggle]');
      this.intro = this.querySelector('[data-collection-seo-intro]');
      this.rest = this.querySelector('[data-collection-seo-rest]');

      if (!this.toggle || !this.rest) return;

      this.labelMore = this.toggle.querySelector('.collection-seo__toggle-label--more');
      this.labelHide = this.toggle.querySelector('.collection-seo__toggle-label--hide');

      this.toggle.addEventListener('click', this.onToggle.bind(this));
    }

    onToggle() {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      const toggleTop = this.toggle.getBoundingClientRect().top;

      this.toggle.setAttribute('aria-expanded', String(!expanded));
      this.labelMore.setAttribute('aria-hidden', String(!expanded));
      this.labelHide.setAttribute('aria-hidden', String(expanded));
      this.intro.classList.toggle('collection-seo__intro--clamped', expanded);
      this.rest.hidden = expanded;

      if (expanded) {
        // Mobile re-clamps the intro above the button
        window.scrollBy(0, this.toggle.getBoundingClientRect().top - toggleTop);
      } else {
        this.rest.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('collection-seo-description', CollectionSeoDescription);
}
